export const PoemMillion = () => {
    return (
        <div id="031" className="">
            <p>i am</p>
            <p>
                poured asphalt on a horizontal plane on an intersection with
                reinforced concrete structures, i am
            </p>
            <p>corners, crossroads, street signs and stoplights, i am</p>
            <p>things put into place in a 90 degrees angle, yet i am</p>
            <p>crumpled paper blowing in the wind,</p>
            <p>grass growing in the cracks in the pavement,</p>
            <p>oil spots and dents in the ground that you walk on, i'm</p>
            <p>
                scenes and scenery into lightwaves and retinas, electrical
                impulses to the -
            </p>
            <p>
                i am straight poles and lamp posts and street signs and
                signposts,
            </p>
            <p>i am</p>
            <p>
                electricity, dial-up, ethernet cables that twist underground, i
                am
            </p>
            <p>
                pipes and pipelines and faucets and valves that spin and are
                spun
            </p>
            <p>
                i am gloves that are black and gray and have holes covering
                hands that grab levers and
            </p>
            <p>handles and door knobs and doors,</p>
            <p>i am</p>
            <p>rust particles on concrete walls, i</p>
            <p>age, deteriorate, crumble and force</p>
            <p>things in and out of positions</p>
            <p>of action, inaction and complete connection</p>
            <p>i am</p>
            <p>sunsets with red yellow crimson charcoal suns that breathe in</p>
            <p>air and all kinds of exhaustion fumes, i am</p>
            <p>steam inside and outside of machine lungs, i am</p>
            <p>wrenches and bolts twisted into metal plates, i'm</p>
            <p>
                an LED light inside a million dots and particles that change
                their colors.
            </p>
        </div>
    );
};
